import Reveal from "@/components/base/Reveal";
import Eyebrow from "@/components/base/Eyebrow";
import Badge from "@/components/base/Badge";
import { tips } from "@/mocks/site";
import { buildWhatsAppLink } from "@/utils/links";

export default function TipsSection() {
  return (
    <section id="tips" className="relative overflow-hidden bg-background-50">
      <div className="pointer-events-none absolute -right-24 top-20 h-[340px] w-[340px] rounded-full glow-rose blur-3xl" />
      <div className="pointer-events-none absolute -left-24 bottom-16 h-[320px] w-[320px] rounded-full glow-clinic blur-3xl" />
      <div className="relative mx-auto w-full max-w-[1400px] px-5 py-20 md:px-10 md:py-24">
        <Reveal className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <Eyebrow>Tips ALÉA</Eyebrow>
            <h2 className="mt-3 font-heading text-4xl font-bold leading-[1.05] text-foreground-950 md:text-5xl">
              Hábitos que sostienen tus resultados
            </h2>
          </div>
          <p className="max-w-md text-[15px] leading-relaxed text-foreground-600">
            Lo que haces en casa cuida lo que trabajamos en clínica. Estos hábitos simples marcan la
            diferencia.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {tips.map((tip, index) => (
            <Reveal
              key={tip.title}
              delay={(index % 4) * 80}
              className="card-soft group relative flex flex-col overflow-hidden rounded-[24px] border border-secondary-200 bg-background-50 p-6 transition-all duration-500 hover:-translate-y-1 hover:card-premium"
            >
              <span className="absolute inset-x-0 top-0 h-[3px] bar-rose" />
              <Badge tone="soft" className="w-fit">
                {tip.label}
              </Badge>
              <span className="mt-4 flex h-12 w-12 items-center justify-center rounded-[14px] border border-accent-200 bg-accent-50 text-accent-700">
                <i className={`${tip.icon} text-xl`} />
              </span>
              <h3 className="mt-5 font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
                {tip.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{tip.text}</p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120} className="mt-10 flex justify-center">
          <a
            href={buildWhatsAppLink("Hola ALÉA, quiero recibir una recomendación de rutina de skincare.")}
            target="_blank"
            rel="noreferrer"
            className="cta-primary inline-flex min-h-[48px] items-center gap-2 whitespace-nowrap rounded-[16px] bg-primary-500 px-7 font-label text-[11px] font-semibold uppercase tracking-[0.14em] text-background-50 transition-all duration-300 hover:bg-primary-600"
          >
            Recibir recomendación
            <i className="ri-magic-line text-base" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}